import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 9, viewBox: "0 0 18 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.4142 7.58579C9.63316 8.36684 8.36683 8.36683 7.58579 7.58579L0 0H18L10.4142 7.58579Z", fill: "#1A2023" }));
const ForwardRef = forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
